export const initFormLabel = () => {
  const formLabel = document.querySelector(
    'body .email-signup .email-signup-form .gform-body.gform_body .ginput_container.ginput_container_email input',
  );

  formLabel.setAttribute('aria-label', 'sign up');
};
